import { Color, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getFileSizeLabel } from '../../../../../../../../utils/getFileSizeLabel'
import { ActionText } from '../../../../../ActionText'
import * as Styled from './styles'

const DONE_PROGRESS_LEVEL = 100

interface UploadHeaderProps {
  fileName: string
  onCancel: () => void
  progress: number
  uploadedBytes?: number
}

export const UploadHeader = ({ fileName, onCancel, progress, uploadedBytes }: UploadHeaderProps): ReactElement => {
  const { t } = useTranslation()

  const uploadProgressMessage = t('attachments_list.upload.progress', {
    progressPercent: Math.floor(progress),
    loadedFileSize: getFileSizeLabel(uploadedBytes),
  })

  const isCancelDisabled = progress === DONE_PROGRESS_LEVEL

  return (
    <Flex justifyContent="space-between">
      <Styled.FileNameWrapper>
        <Text variant="bodySM" truncate>
          {fileName}
        </Text>
      </Styled.FileNameWrapper>
      <Flex gap={Spacing.S8}>
        <Text color={Color.Grey950} variant="bodySM">
          {uploadProgressMessage}
        </Text>
        <ActionText onClick={onCancel} isDisabled={isCancelDisabled}>
          {t('attachments_list.upload.cancel')}
        </ActionText>
      </Flex>
    </Flex>
  )
}
